export class GcpVmResource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "disks",
            "baseName": "disks",
            "type": "Array<InventoryGcpDisk>",
            "format": ""
        },
        {
            "name": "operatingSystem",
            "baseName": "operatingSystem",
            "type": "OperatingSystem",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpVmResource.attributeTypeMap;
    }
    constructor() {
    }
}
